import PropTypes from 'prop-types'
import React, { useState } from "react"

import { connect } from "react-redux"
import ReactDrawer from 'react-drawer';
import 'react-drawer/lib/react-drawer.css';
  
// Reactstrap
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Input } from "reactstrap"

// Import menuDropdown
import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown"
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu"
import RightSidebar from "../CommonForBoth/RightSidebar"

//i18n
import { withTranslation } from "react-i18next"

// Redux Store
import {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
  getFilters,
  applyFilterProperty,
  applyFilterBlock,
} from "../../store/actions"

const Header = props => {
  const [search, setsearch] = useState(false)
  const [propertiesMenu, setPropertiesMenu] = useState(false)
  const [blocksMenu, setBlocksMenu] = useState(false)
  const [socialDrp, setsocialDrp] = useState(false)

  const [properties, setProperties] = React.useState([]);
  const [blocks, setBlocks] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  const [queryProperty, setQueryProperty] = React.useState('');
  const [queryBlock, setQueryBlock] = React.useState('');

  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)

  const [position, setPosition] = useState();
  const [open, setOpen] = useState(false);

  function toggleRightDrawer() {
    setPosition('right');
    setOpen(!open)
  }

  const onDrawerClose = () => {
    setOpen(false);
  }

  function toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen()
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen()
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        )
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen()
      }
    }
  }

  function tToggle() {
    var body = document.body;
    body.classList.toggle("vertical-collpsed");
    body.classList.toggle("sidebar-enable");
  }

  const init= async() => {
    // console.log('init');

    if(props.filters.length < 1) {
      let lUser = await localStorage.getItem('authUser');
      if(lUser) {
        await props.getFilters(JSON.parse(lUser).id);
      }
      else {
        console.log('not logged in');
      }
    }


    if(props.filters.length > 0) {
      let localBlock = await JSON.parse(localStorage.getItem('userBlock'));
      let localProperty = await JSON.parse(localStorage.getItem('userProperty'));
      console.log(localBlock, localProperty);
      if(localBlock && localProperty) {
        let tProp = await props.filters.find(f => f.id == localProperty.id);
        if(tProp) {
          let tBlock = await tProp.blocks.find(b => ((b.id == localBlock.id) && (b.property_id == localProperty.id)));
          if(tBlock) {
            props.applyFilterProperty(tProp);
            props.applyFilterBlock(tBlock);
          }
        }
      }
      
    }
  }


  React.useEffect(()=>{
      init();
  }, [props.filters]);



  // React.useEffect(()=>{
  //   // console.log('Header loaded', props.filters);
  //   init();
  // }, []);


  const displayedProperties = queryProperty == '' ? props.filters : (props.filters.length < 1 ? [] : props.filters.filter(p => p.name.toLowerCase().includes(queryProperty.toLowerCase())));
  const displayedBlocks = queryBlock == '' ? (props.filterProperty ? props.filterProperty.blocks : []) : props.filterProperty?.blocks.filter(b => b.name.toLowerCase().includes(queryBlock.toLowerCase()));


  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            <button
              type="button"
              onClick={() => {
                tToggle()
              }}
              className="btn btn-sm px-3 font-size-16 header-item "
              id="vertical-menu-btn"
            >
              <i className="fa fa-fw fa-bars" />
            </button>

            <Dropdown
              isOpen={propertiesMenu}
              toggle={() =>
                setPropertiesMenu(!propertiesMenu)
              }
              >
              <DropdownToggle tag="button" className="btn header-item" caret>
                {props.filterProperty ? props.filterProperty.name : 'Select property'}{" "}
                <i className="mdi mdi-chevron-down"></i>
              </DropdownToggle>
              <DropdownMenu >
                <div className='px-1 pb-2'>
                  <Input type="search" placeholder="Search.." autoFocus 
                    className='form-control'
                    value={queryProperty}
                    onChange={e=>setQueryProperty(e.target.value)}
                    />
                </div>
                
                { displayedProperties.map((prop, propIdx)=>(
                <DropdownItem key={propIdx} onClick={()=>{ 
                  props.applyFilterProperty(prop);
                  localStorage.setItem('userProperty', JSON.stringify(prop));
                  setPropertiesMenu(false);
                  setBlocksMenu(true);
                  setQueryBlock('');
                 }}>{prop.name}</DropdownItem>
                ))}
              </DropdownMenu>
            </Dropdown>

            <Dropdown
              isOpen={blocksMenu}
              toggle={() =>
                setBlocksMenu(!blocksMenu)
              }
              >
              <DropdownToggle tag="button" 
                className="btn header-item" 
                disabled={!props.filterProperty}
                caret>
                {props.filterBlock ? props.filterBlock.name : 'Select block'}{" "}
                <i className="mdi mdi-chevron-down"></i>
              </DropdownToggle>
              <DropdownMenu >
                <div className='px-1 pb-2'>
                  <Input type="search" placeholder="Search.." autoFocus 
                    className='form-control'
                    value={queryBlock}
                    onChange={e=>setQueryBlock(e.target.value)}
                    />
                </div>
                { displayedBlocks.map((blk, blkIdx)=>(
                <DropdownItem key={blkIdx} onClick={()=>{ 
                  props.applyFilterBlock(blk);
                  localStorage.setItem('userBlock', JSON.stringify(blk));
                  setBlocksMenu(false);
                 }}>{blk.name}</DropdownItem>
                ))}
              </DropdownMenu>
            </Dropdown>          
          
          </div>
          <div className="d-flex">
            <div className="dropdown d-none d-lg-inline-block ms-1">
              <button
                type="button"
                onClick={() => {
                  toggleFullscreen()
                }}
                className="btn header-item noti-icon"
                data-toggle="fullscreen"
              >
                <i className="bx bx-fullscreen" />
              </button>
            </div>

            {/* <NotificationDropdown /> */}
            <ProfileMenu />

            {/* <div
              onClick={() => {
                toggleRightDrawer()
              }}
              disabled={open}
              className="dropdown d-inline-block"
            >
              <button
                type="button"
                className="btn header-item noti-icon right-bar-toggle"
              >
                <i className="bx bx-cog bx-spin" />
              </button>
            </div> */}
          </div>
        </div>
        <ReactDrawer
          open={open}
          position={position}
          onClose={onDrawerClose}
        >
          {/* {console.log(open)} */}
          <RightSidebar onClose={onDrawerClose} />
        </ReactDrawer>
      </header>

    </React.Fragment>
  )
}

Header.propTypes = {
  changeSidebarType: PropTypes.func,
  leftMenu: PropTypes.any,
  leftSideBarType: PropTypes.any,
  filters: PropTypes.array,
  filterProperty: PropTypes.object,
  filterBlock: PropTypes.object,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
}

const mapStatetoProps = (state) => {
  const {
    layoutType,
    showRightSidebar,
    leftMenu,
    leftSideBarType,
  } = state.Layout
  const {
    filters,
    filterProperty,
    filterBlock,
    applyFilterProperty,
    applyFilterBlock,
  } = state.filters
  return { layoutType, showRightSidebar, leftMenu, leftSideBarType, filters, 
      filterProperty, filterBlock,
      applyFilterProperty,
      applyFilterBlock, }
}


export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
  getFilters,
  applyFilterProperty,
  applyFilterBlock,
})(Header)
